export default {
  ocorrencias: [],
  eventos: [],
}
